(function() {
    "use strict";
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var cluck = document.getElementById("cluck");
    if (cluck) {
        var cio = new IntersectionObserver(function(en) {
            if (en[0].isIntersecting) {
                cluck.src = cluck.getAttribute("data-src");
                cio.disconnect();
            }
        }, {
            rootMargin: "600px 0px"
        });
        cio.observe(cluck);
        var stagePad = 28;
        function fitGame() {
            var stage = document.getElementById("play-stage"), port = document.getElementById("play-port");
            if (!stage || !port) return;
            var gw = window.matchMedia("(max-width:640px)").matches ? 310 : 760;
            var gh = gw === 310 ? 450 : 520;
            var avail = stage.clientWidth - stagePad * 2;
            var scale = Math.min(1, avail / gw);
            port.style.transform = "scale(" + scale + ")";
            stage.style.height = Math.round(gh * scale + stagePad * 2) + "px";
        }
        window.addEventListener("resize", fitGame);
        fitGame();
        setTimeout(fitGame, 300);
    }
    var mechMore = document.getElementById("mech-more"), mechTiles = document.getElementById("mech-tiles");
    if (mechMore) mechMore.addEventListener("click", function() {
        var open = mechTiles.classList.toggle("open");
        mechMore.setAttribute("aria-expanded", String(open));
        mechMore.textContent = open ? "Show fewer" : "Three more mechanics";
        if (open) mechTiles.querySelectorAll(".rv").forEach(function(el) {
            el.classList.add("in");
        });
    });
    var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
            if (e.isIntersecting) {
                e.target.classList.add("in");
                io.unobserve(e.target);
            }
        });
    }, {
        threshold: .12
    });
    document.querySelectorAll(".rv").forEach(function(el) {
        io.observe(el);
    });
    var funnel = document.getElementById("funnel");
    if (funnel) {
        var fio = new IntersectionObserver(function(entries) {
            entries.forEach(function(e) {
                if (e.isIntersecting) {
                    funnel.querySelectorAll(".f-fill").forEach(function(f, i) {
                        setTimeout(function() {
                            f.style.width = f.getAttribute("data-w");
                        }, i * 180);
                    });
                    fio.disconnect();
                }
            });
        }, {
            threshold: .4
        });
        fio.observe(funnel);
    }
    var strip = document.querySelector(".stat-strip");
    if (strip) {
        var sio = new IntersectionObserver(function(entries) {
            entries.forEach(function(en) {
                if (!en.isIntersecting) return;
                sio.disconnect();
                if (reduce) return;
                strip.querySelectorAll(".stat .n").forEach(function(el) {
                    var m = el.textContent.match(/[\d.]+/);
                    if (!m) return;
                    var target = parseFloat(m[0]);
                    var dec = m[0].indexOf(".") > -1 ? 1 : 0;
                    var suffix = el.querySelector("em") ? el.querySelector("em").textContent : "";
                    var t0 = performance.now();
                    (function tick(t) {
                        var k = Math.min((t - t0) / 1100, 1);
                        k = 1 - Math.pow(1 - k, 3);
                        el.innerHTML = (target * k).toFixed(dec) + "<em>" + suffix + "</em>";
                        if (k < 1) requestAnimationFrame(tick);
                    })(t0);
                });
            });
        }, {
            threshold: .5
        });
        sio.observe(strip);
    }
    var cv = document.getElementById("engine");
    if (cv) {
        var ctx = cv.getContext("2d");
        var stage = cv.parentElement;
        var W = 0, H = 0, DPR = 1;
        function size() {
            DPR = Math.min(window.devicePixelRatio || 1, 2);
            W = stage.clientWidth;
            H = stage.clientHeight;
            cv.width = W * DPR;
            cv.height = H * DPR;
            ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
            ctx.fillStyle = "#fff";
            ctx.fillRect(0, 0, W, H);
        }
        size();
        window.addEventListener("resize", size);
    }
    var INK = "11,13,23", VIOLET = "109,77,242", PINK = "252,24,191", GREY = "171,175,192", GREEN = "34,197,94";
    var dots = [], pulses = [], threads = [], labels = [], converted = 0, sessions = 1208;
    var evChip = document.getElementById("c-event"), evText = document.getElementById("c-event-text"), cFtds = document.getElementById("c-ftds"), chipOut = document.getElementById("chip-out"), cSess = document.getElementById("c-sessions");
    var evTimer = null;
    function core() {
        return {
            x: W * 0.5,
            y: H * 0.5,
            r: Math.min(H, W) * 0.15
        };
    }
    function spawn(seedX) {
        var band = [
            H * 0.22,
            H * 0.82
        ];
        var d = {
            x: seedX === undefined ? -12 : seedX,
            y: band[0] + Math.random() * (band[1] - band[0]),
            vx: 36 + Math.random() * 42,
            ph: Math.random() * 6.28,
            amp: 5 + Math.random() * 9,
            st: "flow",
            t: 0,
            r: 2.1 + Math.random() * 1.2,
            leaveAt: Math.random() < 0.34 ? 0.14 + Math.random() * 0.34 : -1,
            vy: 0,
            path: null,
            tt: 0,
            intent: 40 + Math.floor(Math.random() * 55),
            serve: 0
        };
        d.baseY = d.y;
        dots.push(d);
    }
    for(var i = 0; i < 28; i++)spawn(Math.random() * W * 0.9);
    var srLive = document.getElementById("sr-live");
    var spot = null, spotPhase = 0, spotT = 0, spotTimer = 0, dim = 1, spotId = "";
    function fireEvent(html, force) {
        if (spotPhase > 0 && !force) return;
        evText.innerHTML = html;
        if (srLive) srLive.textContent = html.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
        evChip.classList.add("on");
        clearTimeout(evTimer);
        evTimer = setTimeout(function() {
            evChip.classList.remove("on");
        }, 2600);
    }
    function bumpChip(el) {
        el.classList.remove("bump");
        el.offsetWidth;
        el.classList.add("bump");
    }
    var mouse = {
        x: 0,
        y: 0,
        on: false,
        py: 0,
        pt: 0,
        cool: 0
    };
    stage.addEventListener("pointermove", function(e) {
        var r = cv.getBoundingClientRect();
        var nx = e.clientX - r.left, ny = e.clientY - r.top;
        var now = performance.now();
        if (mouse.on && mouse.pt) {
            var dtms = Math.max(now - mouse.pt, 8);
            var vy = (ny - mouse.py) / dtms * 1000;
            if (vy < -620 && ny < H * 0.42 && mouse.cool <= 0) {
                mouse.cool = 7;
                pulses.push({
                    x: nx,
                    y: ny,
                    r: 10,
                    a: 0.9
                });
                var c = core();
                threads.push({
                    x1: c.x,
                    y1: c.y,
                    x2: nx,
                    y2: ny,
                    prog: 0,
                    a: 1
                });
                if (W < 560) labels.length = 0;
                labels.push({
                    x: nx + 12,
                    y: ny - 6,
                    txt: "Risk " + (88 + Math.floor(Math.random() * 9)) + "%",
                    a: 1
                });
                fireEvent("<b>Exit vector detected</b><small>that one was you</small>");
            }
        }
        mouse.x = nx;
        mouse.y = ny;
        mouse.py = ny;
        mouse.pt = now;
        mouse.on = true;
    });
    stage.addEventListener("pointerleave", function() {
        mouse.on = false;
    });
    var last = performance.now(), running = true, visible = true;
    var eio = new IntersectionObserver(function(en) {
        visible = en[0].isIntersecting;
    }, {
        threshold: 0
    });
    eio.observe(stage);
    document.addEventListener("visibilitychange", function() {
        running = !document.hidden;
    });
    function drawLanes() {
        ctx.lineWidth = 1;
        for(var i = 0; i < 5; i++){
            var y = H * 0.26 + i * (H * 0.54 / 4);
            ctx.strokeStyle = "rgba(" + INK + ",0.05)";
            ctx.beginPath();
            ctx.moveTo(0, y);
            ctx.bezierCurveTo(W * 0.3, y - 8, W * 0.7, y + 8, W, y);
            ctx.stroke();
        }
    }
    function drawCore(t, c) {
        for(var j = 1; j <= 3; j++){
            ctx.strokeStyle = "rgba(" + VIOLET + "," + (0.15 - j * 0.033) + ")";
            ctx.beginPath();
            ctx.arc(c.x, c.y, c.r * j * 0.66, 0, 6.283);
            ctx.stroke();
        }
        ctx.save();
        ctx.setLineDash([
            2,
            7
        ]);
        ctx.lineDashOffset = -t / 40;
        ctx.strokeStyle = "rgba(" + VIOLET + ",0.3)";
        ctx.beginPath();
        ctx.arc(c.x, c.y, c.r * 0.42, 0, 6.283);
        ctx.stroke();
        ctx.restore();
        if (ctx.createConicGradient) {
            var grad = ctx.createConicGradient(t / 1400, c.x, c.y);
            grad.addColorStop(0, "rgba(" + VIOLET + ",0)");
            grad.addColorStop(0.12, "rgba(" + PINK + ",0.32)");
            grad.addColorStop(0.16, "rgba(" + VIOLET + ",0)");
            grad.addColorStop(1, "rgba(" + VIOLET + ",0)");
            ctx.strokeStyle = grad;
            ctx.lineWidth = 2;
            ctx.beginPath();
            ctx.arc(c.x, c.y, c.r * 1.98, 0, 6.283);
            ctx.stroke();
            ctx.lineWidth = 1;
        }
        for(var o = 0; o < 3; o++){
            var a = t / 1000 * (0.5 + o * 0.23) + o * 2.1;
            ctx.fillStyle = "rgba(" + VIOLET + ",0.55)";
            ctx.beginPath();
            ctx.arc(c.x + Math.cos(a) * c.r * 0.66, c.y + Math.sin(a) * c.r * 0.66, 2, 0, 6.283);
            ctx.fill();
        }
        var breathe = 8 + Math.sin(t / 600) * 1.6;
        var rg = ctx.createRadialGradient(c.x, c.y, 0, c.x, c.y, breathe * 2.4);
        rg.addColorStop(0, "rgba(" + PINK + ",0.35)");
        rg.addColorStop(1, "rgba(" + PINK + ",0)");
        ctx.fillStyle = rg;
        ctx.beginPath();
        ctx.arc(c.x, c.y, breathe * 2.4, 0, 6.283);
        ctx.fill();
        var g2 = ctx.createLinearGradient(c.x - 8, c.y - 8, c.x + 8, c.y + 8);
        g2.addColorStop(0, "rgba(" + VIOLET + ",1)");
        g2.addColorStop(1, "rgba(" + PINK + ",1)");
        ctx.fillStyle = g2;
        ctx.beginPath();
        ctx.arc(c.x, c.y, 5, 0, 6.283);
        ctx.fill();
    }
    if (reduce) {
        drawLanes();
        drawCore(0, core());
        dots.slice(0, 18).forEach(function(d) {
            ctx.fillStyle = "rgba(" + INK + ",0.5)";
            ctx.beginPath();
            ctx.arc(d.x, d.baseY, d.r, 0, 6.283);
            ctx.fill();
        });
    } else {
        var spawnAcc = 0, sessAcc = 0;
        var coarse = window.matchMedia("(pointer:coarse)").matches;
        (function frame(t) {
            requestAnimationFrame(frame);
            if (!running || !visible) {
                last = t;
                return;
            }
            if (coarse && t - last < 30) return;
            var dt = Math.min((t - last) / 1000, 0.05);
            last = t;
            var c = core();
            mouse.cool = Math.max(0, mouse.cool - dt);
            spawnAcc += dt;
            if (spawnAcc > 0.22 && dots.length < 64) {
                spawnAcc = 0;
                spawn();
            }
            sessAcc += dt;
            if (sessAcc > 1.6) {
                sessAcc = 0;
                sessions += Math.floor(Math.random() * 7) - 3;
                cSess.textContent = sessions.toLocaleString("en-GB") + " being read";
            }
            ctx.fillStyle = "rgba(255,255,255,0.2)";
            ctx.fillRect(0, 0, W, H);
            drawLanes();
            drawCore(t, c);
            var flows = dots.filter(function(d) {
                return d.st === "flow" || d.st === "conv";
            });
            ctx.lineWidth = 1;
            for(var a = 0; a < flows.length; a++)for(var b2 = a + 1; b2 < flows.length; b2++){
                var A = flows[a], B = flows[b2];
                var dx = A.x - B.x, dy = A.y - B.y;
                if (Math.abs(dx) > 86 || Math.abs(dy) > 86) continue;
                var dist = Math.hypot(dx, dy);
                if (dist < 86) {
                    var al = (1 - dist / 86) * 0.08 * dim;
                    var pinky = A.st === "conv" || B.st === "conv";
                    ctx.strokeStyle = "rgba(" + (pinky ? PINK : INK) + "," + (pinky ? al * 1.6 : al) + ")";
                    ctx.beginPath();
                    ctx.moveTo(A.x, A.y);
                    ctx.lineTo(B.x, B.y);
                    ctx.stroke();
                }
            }
            for(var L = threads.length - 1; L >= 0; L--){
                var lk = threads[L];
                if (lk.prog < 1) lk.prog = Math.min(lk.prog + dt * 3.4, 1);
                else lk.a -= dt * 1.7;
                if (lk.a <= 0) {
                    threads.splice(L, 1);
                    continue;
                }
                var ex = lk.x1 + (lk.x2 - lk.x1) * lk.prog, ey = lk.y1 + (lk.y2 - lk.y1) * lk.prog;
                var lg = ctx.createLinearGradient(lk.x1, lk.y1, lk.x2, lk.y2);
                lg.addColorStop(0, "rgba(" + VIOLET + "," + lk.a * 0.7 + ")");
                lg.addColorStop(1, "rgba(" + PINK + "," + lk.a * 0.85 + ")");
                ctx.strokeStyle = lg;
                ctx.lineWidth = 1.4;
                ctx.beginPath();
                ctx.moveTo(lk.x1, lk.y1);
                ctx.lineTo(ex, ey);
                ctx.stroke();
                ctx.lineWidth = 1;
            }
            for(var P = pulses.length - 1; P >= 0; P--){
                var p = pulses[P];
                p.r += dt * 190;
                p.a -= dt * 1.3;
                if (p.a <= 0) {
                    pulses.splice(P, 1);
                    continue;
                }
                ctx.strokeStyle = "rgba(" + (p.col || PINK) + "," + p.a + ")";
                ctx.lineWidth = 1.6;
                ctx.beginPath();
                ctx.arc(p.x, p.y, p.r, 0, 6.283);
                ctx.stroke();
                ctx.lineWidth = 1;
            }
            ctx.font = "500 11px Inter, sans-serif";
            for(var Z = labels.length - 1; Z >= 0; Z--){
                var lb = labels[Z];
                lb.y -= dt * 13;
                lb.a -= dt * 0.75;
                if (lb.a <= 0) {
                    labels.splice(Z, 1);
                    continue;
                }
                ctx.fillStyle = "rgba(" + PINK + "," + Math.min(lb.a, 1) + ")";
                ctx.fillText(lb.txt, lb.x, lb.y);
            }
            spotTimer += dt;
            if (spotPhase === 0 && spotTimer > 18) {
                for(var C = 0; C < dots.length; C++){
                    var cand = dots[C];
                    if (cand.st === "flow" && cand.x > W * 0.14 && cand.x < W * 0.38 && cand.y > H * 0.28 && cand.y < H * 0.72) {
                        spot = cand;
                        spotPhase = 1;
                        spotT = 0;
                        spot.leaveAt = -1;
                        spotId = "0x" + Math.random().toString(16).slice(2, 6);
                        fireEvent("<b>Reading session " + spotId + "</b><small>signals streaming</small>", true);
                        break;
                    }
                }
                if (!spot) spotTimer = 14;
            }
            if (spotPhase > 0) {
                if (!spot || dots.indexOf(spot) < 0) {
                    if (spot && spot.st === "leaving") fireEvent("<b>Session " + spotId + " lost</b><small>not every leave is catchable</small>", true);
                    spot = null;
                    spotPhase = 0;
                    spotTimer = 0;
                } else {
                    spotT += dt;
                    if (spotPhase === 1 && spotT > 1.3) {
                        spotPhase = 2;
                        spot.st = "leaving";
                        spot.vy = -(30 + Math.random() * 16);
                    }
                    if (spotPhase === 2 && spot.st === "caught") {
                        spotPhase = 3;
                        fireEvent("<b>Exit vector detected</b><small>experience served: wheel</small>", true);
                    }
                }
            }
            var dimTarget = spotPhase > 0 ? 0.28 : 1;
            dim += (dimTarget - dim) * Math.min(dt * 4, 1);
            stage.dataset.phase = spotPhase;
            for(var D = dots.length - 1; D >= 0; D--){
                var d = dots[D];
                d.t += dt;
                if (d.st === "flow") {
                    d.x += d.vx * dt;
                    d.y = d.baseY + Math.sin(d.ph + d.t * 1.4) * d.amp;
                    if (d.leaveAt > 0 && d.x > W * d.leaveAt) {
                        d.st = "leaving";
                        d.leaveAt = -1;
                        d.vy = -(26 + Math.random() * 22);
                    }
                } else if (d.st === "leaving") {
                    d.vy -= dt * 30;
                    d.x += d.vx * 0.45 * dt;
                    d.y += d.vy * dt;
                    var dx2 = d.x - c.x, dy2 = d.y - c.y;
                    if (Math.hypot(dx2, dy2) < c.r * 2 && d.y < d.baseY - 26) {
                        d.st = "caught";
                        d.tt = 0;
                        var ty = H * 0.3 + Math.random() * (H * 0.44);
                        d.path = {
                            x0: d.x,
                            y0: d.y,
                            cx: d.x * 0.35 + c.x * 0.65,
                            cy: d.y * 0.35 + c.y * 0.65,
                            x1: d.x + 150,
                            y1: ty
                        };
                        pulses.push({
                            x: c.x,
                            y: c.y,
                            r: 12,
                            a: 0.85
                        });
                        threads.push({
                            x1: c.x,
                            y1: c.y,
                            x2: d.x,
                            y2: d.y,
                            prog: 0,
                            a: 1
                        });
                        if (W < 560) labels.length = 0;
                        labels.push({
                            x: d.x + 10,
                            y: d.y - 6,
                            txt: "Risk " + (84 + Math.floor(Math.random() * 14)) + "%",
                            a: 1
                        });
                        var evs = [
                            "<b>Exit vector detected</b><small>wheel served, 2,300ms</small>",
                            "<b>Hesitation flagged</b><small>nudge served at the cashier</small>",
                            "<b>Form stall detected</b><small>registration rescue served</small>",
                            "<b>Exit vector detected</b><small>scratch card served, 1,900ms</small>"
                        ];
                        fireEvent(evs[Math.floor(Math.random() * evs.length)]);
                    }
                    if (d.y < H * 0.06) {
                        pulses.push({
                            x: d.x,
                            y: H * 0.06,
                            r: 5,
                            a: 0.5,
                            col: GREY
                        });
                        dots.splice(D, 1);
                        continue;
                    }
                } else if (d.st === "caught") {
                    d.tt += dt / 0.9;
                    var q = Math.min(d.tt, 1), iq = 1 - q, pth = d.path;
                    var e = 1 - Math.pow(iq, 2.2);
                    var ie = 1 - e;
                    d.x = ie * ie * pth.x0 + 2 * ie * e * pth.cx + e * e * pth.x1;
                    d.y = ie * ie * pth.y0 + 2 * ie * e * pth.cy + e * e * pth.y1;
                    if (q >= 1) {
                        d.st = "conv";
                        d.baseY = pth.y1;
                        d.ph = Math.random() * 6.28;
                        d.t = 0;
                    }
                } else {
                    d.x += d.vx * 1.25 * dt;
                    d.y = d.baseY + Math.sin(d.ph + d.t * 1.4) * d.amp * 0.6;
                }
                if (d.x > W + 14) {
                    if (d.st === "conv") {
                        converted++;
                        cFtds.textContent = "Recovered in this view: " + converted;
                        bumpChip(chipOut);
                        pulses.push({
                            x: W - 14,
                            y: d.y,
                            r: 6,
                            a: 0.7,
                            col: GREEN
                        });
                        if (d === spot) {
                            fireEvent("<b>Deposit confirmed</b><small>session " + spotId + " recovered</small>", true);
                            spot = null;
                            spotPhase = 0;
                            spotTimer = 0;
                        }
                    } else if (d === spot) {
                        spot = null;
                        spotPhase = 0;
                        spotTimer = 0;
                    }
                    dots.splice(D, 1);
                    continue;
                }
                var drawX = d.x, drawY = d.y;
                if (mouse.on) {
                    var mdx = d.x - mouse.x, mdy = d.y - mouse.y;
                    var md = Math.hypot(mdx, mdy);
                    if (md < 70 && md > 0.1) {
                        var push = (70 - md) * 0.3;
                        drawX += mdx / md * push;
                        drawY += mdy / md * push;
                    }
                }
                var col, al;
                if (d.st === "leaving") {
                    col = GREY;
                    al = 0.85;
                } else if (d.st === "caught" || d.st === "conv") {
                    col = PINK;
                    al = 0.95;
                } else {
                    col = INK;
                    al = 0.5;
                }
                if (spotPhase > 0 && d !== spot) al *= dim;
                if (d.st === "caught" || d.st === "conv") {
                    ctx.fillStyle = "rgba(" + PINK + "," + 0.12 * (spotPhase > 0 && d !== spot ? dim : 1) + ")";
                    ctx.beginPath();
                    ctx.arc(drawX, drawY, d.r * 2.6, 0, 6.283);
                    ctx.fill();
                }
                ctx.fillStyle = "rgba(" + col + "," + al + ")";
                ctx.beginPath();
                ctx.arc(drawX, drawY, d.r, 0, 6.283);
                ctx.fill();
                if (d.st === "caught") {
                    var pop = Math.min(d.tt / 0.15, 1) * Math.min((1 - d.tt) / 0.15, 1);
                    pop = Math.max(0, Math.min(pop, 1));
                    if (pop > 0) {
                        var sxc = drawX + 16, syc = drawY - 18, sw = 30 * pop, sh = 22 * pop;
                        ctx.save();
                        ctx.globalAlpha = spotPhase > 0 && d !== spot ? dim : 1;
                        ctx.fillStyle = "#fff";
                        ctx.strokeStyle = "rgba(" + INK + ",0.16)";
                        ctx.beginPath();
                        if (ctx.roundRect) ctx.roundRect(sxc - sw / 2, syc - sh / 2, sw, sh, 5 * pop);
                        else ctx.rect(sxc - sw / 2, syc - sh / 2, sw, sh);
                        ctx.fill();
                        ctx.stroke();
                        var wr = 6.5 * pop, wa = d.tt * 14;
                        ctx.strokeStyle = "rgba(" + PINK + ",0.9)";
                        ctx.beginPath();
                        ctx.arc(sxc, syc, wr, 0, 6.283);
                        ctx.stroke();
                        ctx.beginPath();
                        for(var SP = 0; SP < 4; SP++){
                            var a2 = wa + SP * 1.5708;
                            ctx.moveTo(sxc, syc);
                            ctx.lineTo(sxc + Math.cos(a2) * wr, syc + Math.sin(a2) * wr);
                        }
                        ctx.stroke();
                        ctx.restore();
                    }
                }
                if (d === spot && spotPhase === 1) {
                    ctx.save();
                    ctx.setLineDash([
                        3,
                        5
                    ]);
                    ctx.lineDashOffset = -t / 30;
                    ctx.strokeStyle = "rgba(" + VIOLET + ",0.75)";
                    ctx.beginPath();
                    ctx.arc(drawX, drawY, 11, 0, 6.283);
                    ctx.stroke();
                    ctx.restore();
                }
            }
            if (mouse.on && spotPhase === 0) {
                var best = null, bd = 26;
                for(var Q = 0; Q < dots.length; Q++){
                    var dq = dots[Q];
                    if (dq.st !== "flow" && dq.st !== "conv") continue;
                    var qd = Math.hypot(dq.x - mouse.x, dq.y - mouse.y);
                    if (qd < bd) {
                        bd = qd;
                        best = dq;
                    }
                }
                if (best) {
                    var txt = "Dwell " + Math.round(best.t) + "s \u00B7 Intent " + best.intent;
                    ctx.font = "500 10.5px Inter, sans-serif";
                    var tw = ctx.measureText(txt).width;
                    var bx = best.x + 14, by = best.y - 24;
                    if (bx + tw + 16 > W) bx = best.x - tw - 30;
                    ctx.fillStyle = "#fff";
                    ctx.strokeStyle = "rgba(" + INK + ",0.14)";
                    ctx.beginPath();
                    if (ctx.roundRect) ctx.roundRect(bx - 8, by - 12, tw + 16, 20, 6);
                    else ctx.rect(bx - 8, by - 12, tw + 16, 20);
                    ctx.fill();
                    ctx.stroke();
                    ctx.fillStyle = "rgba(" + INK + ",0.72)";
                    ctx.fillText(txt, bx, by + 2);
                    ctx.strokeStyle = "rgba(" + INK + ",0.2)";
                    ctx.beginPath();
                    ctx.moveTo(best.x + 5, best.y - 5);
                    ctx.lineTo(bx - 8, by - 2);
                    ctx.stroke();
                }
            }
            if (mouse.on) {
                ctx.save();
                ctx.setLineDash([
                    4,
                    6
                ]);
                ctx.lineDashOffset = -t / 28;
                var tg = ctx.createLinearGradient(c.x, c.y, mouse.x, mouse.y);
                tg.addColorStop(0, "rgba(" + VIOLET + ",0.22)");
                tg.addColorStop(1, "rgba(" + PINK + ",0.3)");
                ctx.strokeStyle = tg;
                ctx.beginPath();
                ctx.moveTo(c.x, c.y);
                ctx.lineTo(mouse.x, mouse.y);
                ctx.stroke();
                ctx.restore();
                var yg = ctx.createLinearGradient(mouse.x - 9, mouse.y - 9, mouse.x + 9, mouse.y + 9);
                yg.addColorStop(0, "rgba(" + VIOLET + ",1)");
                yg.addColorStop(1, "rgba(" + PINK + ",1)");
                ctx.strokeStyle = yg;
                ctx.lineWidth = 1.6;
                ctx.beginPath();
                ctx.arc(mouse.x, mouse.y, 9, 0, 6.283);
                ctx.stroke();
                ctx.lineWidth = 1;
                ctx.fillStyle = "rgba(" + INK + ",0.9)";
                ctx.beginPath();
                ctx.arc(mouse.x, mouse.y, 2.4, 0, 6.283);
                ctx.fill();
                ctx.font = "500 11px Inter, sans-serif";
                ctx.fillStyle = "rgba(" + INK + ",0.55)";
                ctx.fillText("You", mouse.x + 15, mouse.y - 11);
            }
        })(last);
    }
    var exit = document.getElementById("exit");
    var fired = false, start = Date.now(), lastFocus = null;
    var landmarks = [
        document.querySelector("header"),
        document.getElementById("main"),
        document.querySelector("footer")
    ];
    function engaged() {
        return Date.now() - start > 15000 || maxScroll > 25;
    }
    function fire() {
        if (fired || !engaged()) return;
        try {
            if (sessionStorage.getItem("icv-exit-demo")) return;
            sessionStorage.setItem("icv-exit-demo", "1");
        } catch (err) {}
        fired = true;
        lastFocus = document.activeElement;
        exit.classList.add("show");
        document.body.style.overflow = "hidden";
        landmarks.forEach(function(el) {
            if (el) el.setAttribute("inert", "");
        });
        document.getElementById("exit-cta").focus();
    }
    document.addEventListener("mouseout", function(e) {
        if (!e.relatedTarget && e.clientY <= 0) fire();
    });
    exit.addEventListener("keydown", function(e) {
        if (e.key !== "Tab") return;
        var f = exit.querySelectorAll("a[href], button");
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
        }
    });
    var isTouch = window.matchMedia("(pointer:coarse)").matches;
    var lastSY = 0, upBurst = 0, maxScroll = 0;
    window.addEventListener("scroll", function() {
        var h = document.documentElement;
        var pct = Math.round(h.scrollTop / (h.scrollHeight - h.clientHeight) * 100);
        if (pct > maxScroll) maxScroll = pct;
        var dy = lastSY - h.scrollTop;
        if (dy > 90) upBurst += dy;
        else if (dy < 0) upBurst = 0;
        if (isTouch && upBurst > 1500 && h.scrollTop < 400 && maxScroll > 25 && Date.now() - start > 8000) fire();
        lastSY = h.scrollTop;
    }, {
        passive: true
    });
    function closeExit() {
        exit.classList.remove("show");
        document.body.style.overflow = "";
        landmarks.forEach(function(el) {
            if (el) el.removeAttribute("inert");
        });
        if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    document.getElementById("exit-x").addEventListener("click", closeExit);
    document.getElementById("exit-cta").addEventListener("click", closeExit);
    exit.addEventListener("click", function(e) {
        if (e.target === exit) closeExit();
    });
    document.addEventListener("keydown", function(e) {
        if (e.key === "Escape") closeExit();
    });
})();

//# sourceMappingURL=iconvert-io.7f8b0ba4.js.map
